import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
import util from '@/libs/util';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'AgencyPromotionEdit',
  data: function data() {
    return {
      isMobile: false,
      fileList: [],
      downUrl: process.env.VUE_APP_DOWNLOAD_URL,
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      imageUrl: null,
      isEdit: false,
      citys: [],
      agencyMemberSettlementItemEnums: [],
      agentAettlementProportions: [],
      title: '',
      form: {
        agencyPromotionId: null,
        agencyUserName: null
      },
      rules: {
        agencyPromotionId: [{
          required: true,
          message: '请输入主键',
          trigger: 'blur'
        }],
        agencyUserName: [{
          required: true,
          message: '请输入代理账号',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.isEdit = false;
      this.form.agencyPromotionId = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.isEdit = true;
      this.form.agencyPromotionId = data.agencyPromotionId;
    },
    updateApi: function updateApi() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.convertPromotionAgency(_this.form);
            case 1:
              _this.$emit('initTableData');
              _this.$message.success('操作成功');
              _this.handleClose();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    save: function save() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this2.form.agencyPromotionId != null) {
            _this2.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this2.updateApi();
            }).catch(function () {
              _this2.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          }
        } else {
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};